@use "foundation/colors";
@use "foundation/responsive";

// Currency link row above the price selector — right-aligned, no label (per design).
.switcher {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 8px;

  .link {
    padding: 0;
    font-family: inherit;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    color: colors.$primary-eerie-black;
    text-decoration: underline;
    background: none;
    border: 0;
    cursor: pointer;
  }
}

// "Switch currency" modal body (rendered inside the shared Modal).
// `max-width` is viewport-relative so the box never overflows on phone/tablet:
// it accounts for the Modal `.section` horizontal padding (32px each side)
// plus a ~16px margin to the screen edge.
.modal {
  width: 480px;
  max-width: calc(100vw - 96px);
  text-align: left;

  // On phone the shared Modal `.section` adds 32px of horizontal padding, but the
  // design calls for a ~327px box (≈16px screen margin) with only 20px of inner
  // padding. Pulling 12px back on each side reclaims that room (32px − 12px = 20px
  // effective) so the title fits on one line, matching the Figma mobile layout.
  @include responsive.phone {
    width: calc(100vw - 73px);
    max-width: none;
    margin-inline: -12px;
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
    margin-bottom: 24px;

    @include responsive.phone {
      gap: 16px;
    }

    .title {
      margin: 0;
      font-size: 32px;
      font-weight: 900;
      line-height: 1.1;
      color: colors.$primary-eerie-black;

      @include responsive.phone {
        font-size: 28px;
      }
    }

    .close {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      padding: 0;
      background: none;
      border: 0;
      cursor: pointer;
    }
  }

  .list {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 400px;
    margin: 0;
    padding: 16px;
    overflow-y: auto;
    list-style: none;
    background-color: colors.$primary-white;
    border: 4px solid #e9e9e9;
    border-radius: 8px;

    @include responsive.phone {
      gap: 8px;
      padding: 12px;
    }

    .option {
      box-sizing: border-box;
      display: block;
      width: 100%;
      padding: 12px 16px;
      font-family: inherit;
      font-size: 20px;
      font-weight: 700;
      line-height: 1.1;
      text-align: left;
      color: colors.$primary-eerie-black;
      background: none;
      border: 3px solid transparent;
      border-radius: 8px;
      cursor: pointer;

      @include responsive.phone {
        padding: 16px;
        font-size: 16px;
      }

      &:hover {
        background-color: rgb(34 34 34 / 5%);
      }

      // Pressed state mirrors the selected look.
      &:active,
      &.selected {
        background-color: rgb(34 34 34 / 5%);
        border-color: colors.$primary-eerie-black;
      }

      &.selected {
        cursor: default;
      }
    }
  }
}
